"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactBootstrap = require("react-bootstrap");

require("./ConnectionLoader.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConnectionLoader = function ConnectionLoader(_ref) {
  var heading1 = _ref.heading1,
      heading2 = _ref.heading2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "esta-content"
  }, heading1), /*#__PURE__*/_react.default.createElement("div", {
    className: "conneting-content"
  }, heading2)));
};

var _default = ConnectionLoader;
exports.default = _default;